import React from 'react'
import { MenuItem, Typography, ListItemText, useTheme } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Icon } from 'packages/eid-icons'

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    minWidth: '16rem',
    fontSize: '1.3rem',
    position: 'relative',
    minHeight: '4rem',
    height: '4rem',
    '&.Mui-selected': {
        color: theme.palette.primary.main,
        backgroundColor: 'rgba(48, 127, 193, 0.07) !important',
        borderLeft: `2px solid ${theme.palette.primary.main}`,
        '& img': {
            opacity: 1,
            filter: 'grayscale(0%) ',
        },
    },
}))

const SortLabelText = styled(Typography)({
    color: '#aab0b4',
    fontSize: '1.2rem',
    marginRight: '0.8rem',
})

const SortingMenuItem = ({ displayName, selected, onClick, order }) => {
    const theme = useTheme()
    return (
        <StyledMenuItem onClick={onClick} selected={selected}>
            <ListItemText>{displayName}</ListItemText>

            {selected && (
                <>
                    <SortLabelText>
                        {order === 'asc' ? 'A-Z' : 'Z-A'}
                    </SortLabelText>

                    <Icon
                        name="ArrowLong"
                        width="1.6rem"
                        height="1.6rem"
                        color={theme.palette.primary.main}
                        direction={order === 'asc' ? 'down' : 'up'}
                    />
                </>
            )}
        </StyledMenuItem>
    )
}

export default SortingMenuItem
